var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('backlink'),_vm._v(" "),_c('h1',[_vm._v("Attributs de demande")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Champs proposés dans le formulaire de demande de location pour compte. Un attribut est défini ici, puis activé matériel par matériel depuis la fiche du produit.")]),_vm._v(" "),_c('AdminTable',{attrs:{"config":_vm.config,"options":_vm.options}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03719cf8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestAttribute/RequestAttributeList.vue
// module id = 1030
// module chunks = 0